// extracted by mini-css-extract-plugin
export var accordionBody = "style-mod--accordion-body--fcabd";
export var accordionIcon = "style-mod--accordion-icon--d4c23";
export var accordionIconOpen = "style-mod--accordion-icon-open--1225a";
export var accordionTitle = "style-mod--accordion-title--d6832";
export var accrodionTitleIcon = "style-mod--accrodion-title-icon--610ef";
export var campaignImg = "style-mod--campaign-img--235f7";
export var pdpAccordion = "style-mod--pdp-accordion--138b5";
export var pdpSnippetDesktop = "style-mod--pdp-snippet-desktop--35cfd";
export var pdpSnippetMobile = "style-mod--pdp-snippet-mobile--9b7a7";
export var toggleHeader = "style-mod--toggle-header--e5b75";